<template>
  <section class="w-100">
    <div class="row border-bottom mx-0">
      <div class="col px-0">
        <form class="form-inline" @submit.prevent>
          <div class="row mx-0 mb-3 w-100" id="gridFilters">
            <div
              class="
                col-sm-10 col-md-12 col-lg-2
                mx-auto mx-lg-0
                px-0
                d-flex
                pe-xl-0
                py-1
                pt-lg-0
              "
            >
              <div class="row my-4 w-100">
                <div class="col-4 col-sm-4 col-md-3 d-block d-md-none">
                  <button
                    class="
                      btn btn-success btn-block
                      text-white
                      rounded
                      d-lg-none
                      small
                    "
                    @click="$emit('toggleFilters')"
                  >
                    <i class="fa fa-filter" aria-hidden="true"></i> Filter
                  </button>
                </div>
                <div
                  class="col-8 col-lg-12 col-sm-8 d-block d-md-none d-xl-block"
                >
                  <input
                    type="text"
                    class="form-control rounded w-100"
                    placeholder="Search"
                    v-model="searchFilter"
                  />
                </div>
              </div>
            </div>
            <div
              class="
                col-12 col-sm-8
                d-flex
                px-0
                align-items-center
                justify-content-center justify-content-md-start
                pe-xl-0 pe-5
                ps-4
              "
              v-if="!learningGrid"
            >
              <label class="fw-bold mx-lg-4 me-4">Status:</label>
              <h5
                :class="
                  'tabswitch' +
                  (this.statusFilter.includes('Current') ? ' active' : ' ')
                "
                @click="toggleStatus('Current')"
              >
                
                 {{ language.includes('en') ? "Current" : "Courant" }}
              </h5>
              <h5
                :class="
                  'tabswitch' +
                  (this.statusFilter.includes('Archive') ? ' active' : ' ')
                "
                @click="toggleStatus('Archive')"
              >
                
                 {{ language.includes('en') ? "Archived" : "Archivé" }}

              </h5>
            </div>
            <div
              class="
                col-12 col-sm-12 col-lg-8
                d-flex
                px-0
                align-items-center
                justify-content-center justify-content-lg-start
                pe-xl-0
                px-0
                pt-4 pt-lg-0
              "
              v-if="learningGrid"
            >
              <label class="fw-bold mx-lg-4 me-4 d-none d-lg-flex">
                 {{
                  language.includes('en') ? "Type" : category.name
                }}
                Type:</label>
              <h5
                v-for="category in resourceTypeFilter"
                :key="category.name"
                :class="{
                  tabswitch: true,
                  active: category.enabled ? true : false,
                }"
                :id="'cat_' + category.id"
                @click="toggleEventType(category)"
              >
                {{
                  category.name == "Online Course" ?
                  
                  (language.includes('en') ? "Course" :"Cours")
                
                   :
                   category.name == "Webinar" ? 
                   (language.includes('en') ? "Webinar" :"Webinaire")
                   : 
                   category.name == "Workshop" ? 
                   (language.includes('en') ? "Workshop" :"Atelier")
                   :category.name == "Conference" ? 
                   (language.includes('en') ? "Conference" :"Conférence")
                   :category.name
                }}
              </h5>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div class="row border-start border-end mx-0">
      <div class="col-md-12">
        <div class="row pt-5 justify-content-start report-grid-row">
          <div
            class="report-grid-item col"
            v-for="report in reports"
            :key="report.id"
            :status="report.status ? report.status.split(' ')[0] : true"
            v-show="
              statusFilter.includes(report.status) &&
              (Object.keys(resourceTypeFilter).length > 0
                ? resourceTypeFilter[report['event-type']].enabled
                : true) &&
              searchTerm(report) &&
              (selectedCategories ? categoryTerm(report) : true) &&
              (selectedCareerStages
                ? selectedCareerStages.includes(report['career-stage-friendly'])
                : true) &&
              report.language == language
            "
          >
            <carousel-item
              :report="report"
              :learningRow="learningGrid ? true : false"
            ></carousel-item>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import CarouselItem from "./CarouselItem.vue"

export default {
  components:{
    CarouselItem
  },
  props: {
    allReports: {
      type: Array,
      required: true,
    },
    category: {
      type: String,
    },
    selectedCategories: {
      type: Array,
      required: false,
    },
    selectedCareerStages: {
      type: Array,
      required: false,
    },
    abbr: {
      type: String,
    },
    current: {
      type: String,
    },
    learningGrid: {
      type: Boolean,
      required: false,
    },
    gridTitle: {
      type: String,
      required: false,
    },
    language:{
      type: String,
      required: false,
    },
  },
  computed: {
    // language() {
    //   return this.getCookie("pll_language") ? this.getCookie("pll_language") : "en";    
    //   },
    
  },
  data() {
    return {
      reports: [],
      resourceTypeFilter: {},
      statusFilter: ["Current", "Archive"],
      searchFilter: "",
    };
  },

  methods: {
    getCookie(name) {
      var dc, prefix, begin, end;

      dc = document.cookie;
      prefix = name + "=";
      begin = dc.indexOf("; " + prefix);
      end = dc.length; // default to end of the string

      if (begin !== -1) {
        begin += 2;
      } else {
        begin = dc.indexOf(prefix);
        if (begin === -1 || begin !== 0) return null;
      }

      if (dc.indexOf(";", begin) !== -1) {
        end = dc.indexOf(";", begin);
      }

      return decodeURI(dc.substring(begin + prefix.length, end)).replace(
        /\"/g,
        ""
      );
    },

    toggleStatus(status) {
      if (this.statusFilter.includes(status)) {
        this.statusFilter.splice(this.statusFilter.indexOf(status), 1);
      } else {
        this.statusFilter.push(status);
      }
      // console.log(this.statusFilter);
    },

    toggleEventType(category) {
      var catFilter = this.resourceTypeFilter;

      for (var cat in this.resourceTypeFilter) {
        if (this.resourceTypeFilter[cat].name == category.name) {
          catFilter[cat].enabled = !this.resourceTypeFilter[cat].enabled;
        } else {
          // console.log("not");
        }
      }
      // console.log(category, JSON.parse(JSON.stringify(catFilter)));

      this.resourceTypeFilter = JSON.parse(JSON.stringify(catFilter));
    },
    searchTerm(report) {
      if (this.searchFilter === "") {
        return true;
      } else {
        return (
          report.post_title
            .toLowerCase()
            .includes(this.searchFilter.toLowerCase()) ||
          report.post_content
            .toLowerCase()
            .includes(this.searchFilter.toLowerCase())
        );
      }
    },
    categoryTerm(report) {
      if (this.selectedCategories.length === 0) {
        return true;
      } else {
        for (var i = 0; i < this.selectedCategories.length; i++) {
          var selected = this.selectedCategories[i];
          if (
            selected.id !== 4320 &&
            selected.id !== 4321 &&
            selected.id !== 3846
          ) {
            if (selected.items.includes(report)) {
              return true;
            }
          }
        }
        //no matches
        return false;
      }
    },
  },
  mounted() {
    // eslint-disable-next-line
    this.reports = Object.entries(this.allReports).map(([key, value]) => {
      if (!this.learningGrid) {
        value.status = value.post_category.split(" ")[0];
        value.category = value.post_category.split(" ")[1];
      } else {
        value.status = "Current";
        value.category = value["event_type"];
      }
      return value;
    });

    this.reports.sort((a, b) => {
      return new Date(a.post_date) - new Date(b.post_date); // descending
    });
    console.log("all reports:", this.reports);
    console.log("sorted", this.reports);

    //populate event type filter
    var categoryList = [];
    for (var r in this.reports) {
      var report = this.reports[r];
      // console.log("checking report for events:", report);
      if (report["event-type"]) {
        //no idea why this isn't working correctly..
        categoryList.push(report["event-type"]);
        // console.log("pushing", report["event-type"], "to", categoryList);
      }
    }
    console.log(categoryList);
    var catArr = [...new Set(categoryList)];
    for (var c in catArr) {
      this.resourceTypeFilter[catArr[c]] = {
        name: catArr[c],
        enabled: true,
      };
    }
    console.log("grid categories: ", this.resourceTypeFilter);
  },
};
</script>

<style>
</style>